import './ko.stringTemplate';

import loaderButton from './templates/loader/button.html';
ko.stringTemplateEngine.instance.addTemplate("loaderButton", loaderButton)

import loaderBlock from './templates/loader/block-element.html';
ko.stringTemplateEngine.instance.addTemplate("loaderBlock", loaderBlock)
